export class Customer {
    customerId: number = 0;
    customerCode: string = '';
    customerName: string = '';
    city: string = '';
    preferredCurrency: string = '';
    isTrucker: boolean = false;
    hasCompliance: boolean = false;
    isCompliant: boolean = false;
}
